import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useGenerateFormItem } from '../../../utils/generateFormItem';
import { FormSection } from '../../../components/FormSection/FormSection';

export const FormExtra = ({
  personnalInformationsFields,
  additionalInformationsFields,
  extraInformationsFields
}) => {
  const { t } = useTranslation();
  const generateFields = useGenerateFormItem();

  const sections = [
    {
      key: 'personal_informations',
      icon: 'user',
      fields: personnalInformationsFields
    },
    {
      key: 'additional_informations',
      icon: 'home',
      fields: additionalInformationsFields
    },
    {
      key: 'extra_informations',
      icon: 'profile',
      fields: extraInformationsFields
    }
  ];

  return (
    <>
      {sections.map(({ key, icon, fields }) => (
        <FormSection
          key={key}
          id={`section-${key}`}
          icon={icon}
          title={t(`pensioners.form.sub_title.${key}`)}
          fields={fields}
        >
          {fields.map((field) => generateFields('pensioners', field))}
        </FormSection>
      ))}
    </>
  );
};

FormExtra.propTypes = {
  personnalInformationsFields: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  additionalInformationsFields: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  extraInformationsFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
